module.exports = __webpack_public_path__ + "img/hero-background-light.67050558.png";